import {
  DELETE_TABLE_DATA_ERROR,
  DELETE_TABLE_DATA_SUCCESS,
  FETCH_PERMISSION_SEARCH_SUCCESS,
  FETCH_PERMISSION_TABLE_ERROR,
  FETCH_PERMISSION_TABLE_SUCCESS,
  FETCH_ROLE_PERMISSION_TABLE_ERROR,
  FETCH_ROLE_PERMISSION_TABLE_SUCCESS,
  FETCH_ROLE_TABLE_ERROR,
  FETCH_ROLE_TABLE_SUCCESS,
  FETCH_TABLE_DATA_ERROR,
  FETCH_TABLE_DATA_SEARCH_SUCCESS,
  FETCH_TABLE_DATA_SUCCESS,
  FETCH_USER_PERMISSION_TABLE_ERROR,
  FETCH_USER_PERMISSION_TABLE_SUCCESS,
  INSERT_TABLE_DATA_ERROR,
  INSERT_TABLE_DATA_SUCCESS,
  MASTERDATA_INSERT_JSON_ERROR,
  MASTERDATA_INSERT_JSON_SUCCESS,
  SET_MANAGGE_DATA_REDUCER,
  UPDATE_TABLE_DATA_ERROR,
  UPDATE_TABLE_DATA_SUCCESS,
} from "../types/manageDataTypes";

const initState = {
  fetchTableDataSuccess: false,
  fetchTableDataError: false,
  tableData: null,

  fetchTableDataSearchSuccess: false,
  searchResults: [],

  updateTableDataSuccess: false,
  updateTableDataError: false,
  updateTableDataMsg: null,

  insertTableDataSuccess: false,
  insertTableDataError: false,
  insertTableDataMsg: null,

  deleteTableDataSuccess: false,
  deleteTableDataError: false,
  deleteTableDataMsg: null,

  fetchRoleTableSuccess: false,
  fetchRoleTableError: false,
  roleTable: null,

  fetchPermissionTableSuccess: false,
  fetchPermissionTableError: false,
  permissionTable: null,

  fetchrolePermissionTableSuccess: false,
  fetchrolePermissionTableError: false,
  rolePermissionTable: null,

  fetchUserPermissionTableSuccess: false,
  fetchUserPermissionTableError: false,
  userPermissionTable: null,

  fetchPermissionSearchResults: [],

  masterDataInsertJsonSuccess: false,
  masterDataInsertJsonError: false,
  masterDataInsertJsonMsg: null,
};

const manageDataReducer = (state = initState, action) => {
  switch (action.type) {
    case FETCH_TABLE_DATA_SUCCESS:
      return {
        ...state,
        fetchTableDataSuccess: true,
        fetchTableDataError: false,
        tableData: action.payload,
      };
    case FETCH_TABLE_DATA_ERROR:
      return {
        ...state,
        fetchTableDataSuccess: false,
        fetchTableDataError: true,
        tableData: null,
      };
    case FETCH_TABLE_DATA_SEARCH_SUCCESS:
      return {
        ...state,
        fetchTableDataSearchSuccess: true,
        searchResults: action.payload || [],
      };
    case UPDATE_TABLE_DATA_SUCCESS:
      return {
        ...state,
        updateTableDataSuccess: true,
        updateTableDataError: false,
        updateTableDataMsg: action.message || "Row updated successfully.",
      };
    case UPDATE_TABLE_DATA_ERROR:
      return {
        ...state,
        updateTableDataSuccess: false,
        updateTableDataError: true,
        updateTableDataMsg: action.message || "Error to update the row",
      };
    case INSERT_TABLE_DATA_SUCCESS:
      return {
        ...state,
        insertTableDataSuccess: true,
        insertTableDataError: false,
        insertTableDataMsg: action.message || "Row insert successfully.",
      };
    case INSERT_TABLE_DATA_ERROR:
      return {
        ...state,
        insertTableDataSuccess: false,
        insertTableDataError: true,
        insertTableDataMsg: action.message || "Internal error.",
      };
    case DELETE_TABLE_DATA_SUCCESS:
      return {
        ...state,
        deleteTableDataSuccess: true,
        deleteTableDataError: false,
        deleteTableDataMsg: action.message || "Internal error.",
      };
    case DELETE_TABLE_DATA_ERROR:
      return {
        ...state,
        deleteTableDataSuccess: false,
        deleteTableDataError: true,
        deleteTableDataMsg: action.message || "Internal error.",
      };
    case FETCH_ROLE_TABLE_SUCCESS:
      return {
        ...state,
        fetchRoleTableSuccess: true,
        fetchRoleTableError: false,
        roleTable: action.payload,
      };
    case FETCH_ROLE_TABLE_ERROR:
      return {
        ...state,
        fetchRoleTableSuccess: false,
        fetchRoleTableError: true,
        roleTable: null,
      };
    case FETCH_PERMISSION_TABLE_SUCCESS:
      return {
        ...state,
        fetchPermissionTableSuccess: true,
        fetchPermissionTableError: false,
        permissionTable: action.payload,
      };
    case FETCH_PERMISSION_TABLE_ERROR:
      return {
        ...state,
        fetchPermissionTableSuccess: false,
        fetchPermissionTableError: true,
        permissionTable: null,
      };
    case FETCH_ROLE_PERMISSION_TABLE_SUCCESS:
      return {
        ...state,
        fetchrolePermissionTableSuccess: true,
        fetchrolePermissionTableError: false,
        rolePermissionTable: action.payload,
      };
    case FETCH_ROLE_PERMISSION_TABLE_ERROR:
      return {
        ...state,
        fetchrolePermissionTableSuccess: false,
        fetchrolePermissionTableError: true,
        rolePermissionTable: null,
      };
    case FETCH_USER_PERMISSION_TABLE_SUCCESS:
      return {
        ...state,
        fetchUserPermissionTableSuccess: true,
        fetchUserPermissionTableError: false,
        userPermissionTable: action.payload,
      };
    case FETCH_USER_PERMISSION_TABLE_ERROR:
      return {
        ...state,
        fetchUserPermissionTableSuccess: false,
        fetchUserPermissionTableError: true,
        userPermissionTable: null,
      };
    case FETCH_PERMISSION_SEARCH_SUCCESS:
      return {
        ...state,
        fetchPermissionSearchResults: action?.payload,
      };
    case MASTERDATA_INSERT_JSON_SUCCESS:
      return {
        ...state,
        masterDataInsertJsonSuccess: true,
        masterDataInsertJsonError: false,
        masterDataInsertJsonMsg:
          action.message || "Masterdata added successfully.",
      };
    case MASTERDATA_INSERT_JSON_ERROR:
      return {
        ...state,
        masterDataInsertJsonSuccess: false,
        masterDataInsertJsonError: true,
        masterDataInsertJsonMsg: action.message || "Internal Error .",
      };
    case SET_MANAGGE_DATA_REDUCER:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

export default manageDataReducer;
